import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {grey300, grey50, orange500, teal300} from 'material-ui/styles/colors';
import T from 'i18n-react';
import LoginService from '../../../services/LoginService';
import './Login.css';
// Enum
import PAGES from '../../../enums/PageEnum';
import COOKIES from '../../../enums/CookieEnum';
import {setCookie} from '../../../utils/CookieUtils';
import {Link} from 'react-router';


const styles = {
    errorStyle: {
        color: orange500,
    },
    underlineStyle: {
        borderColor: orange500,
    },
    hintStyle: {
        color: grey300,
    },
    inputStyle: {
        color: grey50,
    },
    floatingLabelStyle: {
        color: grey300,
    },
    floatingLabelFocusStyle: {
        color: grey300,
    },
    labelStyle: {
        fontWeight: '100',
        letterSpacing: '2px',
    }
};

class Login extends Component {

     /*************************************************
     * **************** LifeCycle ********************
     *************************************************/
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            pass: '',
            error: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.connect = this.connect.bind(this);
    }

    render() {
        return (
            <form onSubmit={this.connect}>
                <h1>{T.translate("login.welcome")} {this.state.error}</h1>
                { this.state.error &&
                <span className="error loginError">{T.translate("login.error")}</span>
                }
                <TextField id="loginFieldControlled"
                            className="loginField"
                            name="login"
                            hintText={T.translate("login.username")}
                            floatingLabelText={T.translate("login.username")}
                            fullWidth={true}
                            hintStyle={styles.hintStyle}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                            inputStyle={styles.inputStyle}
                            value={this.state.login}
                            onChange={this.handleInputChange}/>
                <TextField id="passwordFieldControlled"
                            className="passwordField"
                            name="pass"
                            hintText={T.translate("login.password")}
                            floatingLabelText={T.translate("login.password")}
                            fullWidth={true}
                            hintStyle={styles.hintStyle}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                            inputStyle={styles.inputStyle}
                            type="password"
                            value={this.state.pass}
                            onChange={this.handleInputChange}/>
                <Link to={PAGES.RESET_PASSWORD}>{T.translate("login.forget")}</Link>
                <RaisedButton label={T.translate("login.connect")} primary backgroundColor={teal300} labelColor={grey50} className="sign-in-button" type="submit"/>
            </form>
        )
    }

    /*************************************************
     * *************** Web Service *******************
     *************************************************/

    connect(e){
        e.preventDefault();

        LoginService.connect(this.state.login, this.state.pass)
            .then((data) => {
                if(data && data.token) {
                    setCookie({name: COOKIES.SID, value: data.token});
                    this.props.router.push(PAGES.HOME_PAGE);
                } else {
                    this.setState({error: true});
                }
            })
            .catch(() => {
                this.setState({error: true});
            });
    };

    /*************************************************
     * ****************** Action *********************
     *************************************************/

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value,
            error: false
        });
    }
}

export default (Login);



// WEBPACK FOOTER //
// ./src/ui/connexion/login/Login.js